import React, { useState } from 'react';

const LazyImage = ({ src, alt, className, style, onLoad, onError }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    console.log('LazyImage: Image loaded successfully', src);
    setIsLoaded(true);
    if (onLoad) onLoad();
  };

  const handleError = (error) => {
    console.error('LazyImage: Image failed to load', src, error);
    setHasError(true);
    if (onError) onError(error);
  };

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#f5f5f5',
        ...style
      }}
    >
      {!hasError && (
        <img
          src={src}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isLoaded ? 1 : 0.3,
            transition: 'opacity 0.3s ease-in-out',
            display: 'block'
          }}
        />
      )}

      {hasError && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          fontSize: '14px',
          flexDirection: 'column',
          zIndex: 2
        }}>
          <span style={{ fontSize: '24px', marginBottom: '8px' }}>📚</span>
          <span>Curso</span>
        </div>
      )}

      {!isLoaded && !hasError && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999',
          fontSize: '12px',
          zIndex: 1
        }}>
          Carregando...
        </div>
      )}
    </div>
  );
};

export default LazyImage;
